<template>
<div class="c-header" :class="{'c-header--show': $store.getters.isShowHead}">
  <a href="/special/tenkyu/10color/" class="c-header__logo1">
    <img src="/special/tenkyu/10color/assets/img/common/logo-10color.svg" alt="10 COLORS POLO" height="30" width="244">
  </a>
  <a href="https://www.jack-bunny.net/" target="_blank" class="c-header__logo2">
    <img src="/special/tenkyu/10color/assets/img/common/logo-jb10.svg" alt="Jack Bunny. 10" height="24" width="171">
  </a>
</div>
</template>

<script>
export default {
  data() {
    return { 
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>